/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DropdownButton, Menu } from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const Component = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div>
      <DropdownButton
        isOpen={isMenuOpen}
        onClick={() => setIsMenuOpen((old) => !old)}
        ref={anchorRef}
      >
        Dropdown Button
      </DropdownButton>
      <Menu
        isOpen={isMenuOpen}
        anchorRef={anchorRef}
        onClose={() => setIsMenuOpen(false)}
      >
        <Menu.Items
          htmlAttributes={{
            id: 'default-menu',
          }}
        >
          <Menu.Item title="Action 1" />
          <Menu.Item title="Action 2" />
          <Menu.Item title="Action 3" />
          <Menu.Item title="Action 4" />
        </Menu.Items>
      </Menu>
    </div>
  );
};

export default Component;
